/* SIZESOFTX
=========================================================================================
* Descripción: Provider de administración
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 14/05/2026 |                                   | Creación
* ---------------------------------------------------------------------------------------
*/

import { ComprasProvider } from "./ComprasContext";

export const AllAdministracionProvider = (props) => (
  <ComprasProvider>
    {props.children}
  </ComprasProvider>
);